"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Mon Apr 08 2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowMoveResultDTOConverter
 *
 * @author Tomáš Leity
 */


var WindowMoveResultDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowMoveResultDTOConverter, _DataObjectConverter_);

  function WindowMoveResultDTOConverter() {
    _classCallCheck(this, WindowMoveResultDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowMoveResultDTOConverter).apply(this, arguments));
  }

  return WindowMoveResultDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowMoveResultDTOConverter = WindowMoveResultDTOConverter;